import { ProcessActions } from '../../reflux/process_store';
import { FormActions } from '../../../form/reflux/form_store';
import { ProcessAPI } from 'lecom-api';

import ResponseActions from '../../constants/activity_form_response_actions';
import ProcessActionRoutes from '../../constants/process_action_routes';

import ShowMessageResponseHandler from './complete_activity/show_message_response_handler';
import ResponseHandler from '../../../rest_client/response_handler';

import RestClient from 'rest_client/rest_client';

export default class CompleteActivityResponseHandler {

	static execute(storeItem, response, request) {
		if(!CompleteActivityResponseHandler.validateResponse(response)) {
			return;
		}

		const responseContent = response.entity.content;
		switch(responseContent.nextAction) {
			case ResponseActions.SHOW_MESSAGE:
				CompleteActivityResponseHandler.showMessage(storeItem, responseContent);
				break;
			case ResponseActions.OPEN_ACTIVITY:
				CompleteActivityResponseHandler.openNextActivity(responseContent);
				break;
			default:
				window.parent.postMessage({event: 'REDIRECT_DASHBOARD'}, '*');				
			break;
		}
	}

	static validateResponse(response) {
		return !!response.entity && !!response.entity.content;
	}

	static showMessage(storeItem, responseContent) {
		//TODO: Usar a ProcessAPI para executar a ação.
		const messages = ShowMessageResponseHandler.execute(responseContent);
		ProcessActions.displayFormResultMessages(storeItem.id, messages);
	}

	static getParamURL(param) {
		var query = window.location.search.substring(1);
		var vars = query.split("&");

		for (var i=0; i<vars.length; i++) {
				var pair = vars[i].split("=");

				if(pair[0] == param)
					return pair[1];
		}

		return false;
	}

	static buildNextURL(responseContent) {
		const processIds = this.getResponseContentProcessIds(responseContent);

		const { origin, pathname } = window.location;
		const processInstanceId = "?processInstanceId=" + processIds.processInstanceId;
		const activityInstanceId = "&activityInstanceId=" + processIds.activityInstanceId;
		const cycle = "&cycle=" + processIds.cycle;
		const newWS = this.getParamURL('newWS') === "true" ? "&newWS=" + this.getParamURL('newWS') : "";

		const paramsURL = {
			displayFormHeader: this.getParamURL('displayFormHeader'),
			isMobile: this.getParamURL('isMobile'),
			language: this.getParamURL('language'),
			highContrast: this.getParamURL('highContrast')
		};

		const displayFormHeader = (paramsURL.displayFormHeader ? '&displayFormHeader=' + paramsURL.displayFormHeader : '');
		const isMobile = (paramsURL.isMobile ? '&isMobile=' + paramsURL.isMobile : '');
		const language = (paramsURL.language ? '&language=' + paramsURL.language : '');
		const highContrast = (paramsURL.highContrast === "true" ? '&highContrast=' + paramsURL.highContrast : '');

		let token = "";
		let uuid = "";

		if (processIds.token)
			token = processIds.token ? '&token=' + processIds.token : '';
		else
			uuid = processIds.uuid ? "&uuid=" + processIds.uuid : '';		

		const strUrl = origin + pathname + processInstanceId + activityInstanceId + cycle + newWS + uuid + displayFormHeader + highContrast + isMobile + language + token;		

		return strUrl;
	}

	static openNextActivity(responseContent) {
		var ticket = ProcessAPI.currentProcess().ticket();
		var gatewayUrl = ProcessAPI.currentProcess().gatewayUrl();
		var checkUrl = (gatewayUrl.substring((gatewayUrl.length-1) , gatewayUrl.length) === "/") ? gatewayUrl : gatewayUrl+"/";
		var isMobile = this.getParamURL('isMobile');
		var newWS = this.getParamURL('newWS');

		if (ticket && isMobile && !newWS) {
			RestClient.post(checkUrl + ProcessActionRoutes.AUTHENTICATION_TOKEN, {
				"ticketSSO": ticket
			}).then(response => {
				if (response && response.entity && response.entity.token) {
					responseContent.token = response.entity.token;
					window.location.href = this.buildNextURL(responseContent);
				}
			}, ResponseHandler.displayErrorResponseFlashMessage.bind(this, 'flash-form'));
		}
		else {
			if (isMobile && window.navigator.platform !== "Android")
				window.location = this.buildNextURL(responseContent);
			else
				window.location.href = this.buildNextURL(responseContent);
		}
	}

	static getResponseContentProcessIds(responseContent) {
		const nextActivity = responseContent.activities[0];
		if(!nextActivity) {
			return {};
		}

		return {
			processInstanceId: responseContent.processInstanceId,
			activityInstanceId: nextActivity.activityInstanceId,
			cycle: nextActivity.cycle,
			token: nextActivity.token || responseContent.token,
			uuid: nextActivity.uuid
		};
	}
}
